module.exports = __webpack_public_path__ + "static/media/purple-spot.75f32afe.png";